import _objectWithoutPropertiesLoose from './objectWithoutPropertiesLoose.js';

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

export { _objectWithoutProperties as default };
//# sourceMappingURL=objectWithoutProperties.js.map
